import { all, call, put, takeEvery } from 'redux-saga/effects';
import { gcApi } from '../config/axios';

import {
    FETCH_SOLAR_INTENSITY,
    FETCH_SOLAR_INTENSITY_SUCCESS,
    FETCH_SOLAR_INTENSITY_FAIL,
    FETCH_SOLAR_INTENSITY_FETCHING
} from '../actions/solarIntensityActions.js';
import { FETCH_ACTIVITIES_FOR_DAILY_SUMMARY_FETCHING } from '../actions/ActionTypes';

export function* fetchSolarIntensitySaga(action) {
    let startDate = action.payload.startDate;
    let endDate = action.payload.endDate;
    let previousStartDate = action.payload.previousStartDate;
    let previousEndDate = action.payload.previousEndDate;

    let deviceId = action.payload.deviceId;

    const url =
        startDate === endDate
            ? `/web-gateway/solar/${deviceId}/${startDate}/${endDate}?singleDayView=true`
            : `/device-service/devicemonitoring/solargain/${deviceId}/${startDate}/${endDate}`;
    const previousRangeUrl =
        startDate === endDate
            ? `/web-gateway/solar/${deviceId}/${startDate}/${endDate}?singleDayView=true`
            : `/device-service/devicemonitoring/solargain/${deviceId}/${previousStartDate}/${previousEndDate}`;
    try {
        yield put({
            type: FETCH_SOLAR_INTENSITY_FETCHING
        });

        let response, previousRangeResponse;
        if (startDate === endDate) {
            response = yield call(gcApi.get, url);
        } else {
            [response, previousRangeResponse] = yield all([call(gcApi.get, url), call(gcApi.get, previousRangeUrl)]);
        }

        yield put({
            type: FETCH_SOLAR_INTENSITY_SUCCESS,
            solarTimeLine: response.data.deviceSolarInput || [],
            solarCharge: response.data.solarGainDailyDetailDTOList || [],
            previousSolarCharge: previousRangeResponse
                ? previousRangeResponse.data.solarGainDailyDetailDTOList || []
                : [],
            previousRangeSolarCharge: previousRangeResponse
                ? previousRangeResponse.data.solarGainDailyDetailDTOList || []
                : [],
            calendarDate: startDate,
            calendarRange: startDate + '-' + endDate,
            previousCalendarRange: previousStartDate + '-' + previousEndDate,
            deviceId: deviceId,
            activitySummary: { activitiesList: response.data.activitySummary }
        });
    } catch (e) {
        yield put({
            type: FETCH_SOLAR_INTENSITY_FAIL,
            solarTimeLine: [],
            solarCharge: [],
            solarGainDailyDetailDTOList: [],
            calendarDate: startDate,
            deviceId: deviceId
        });
    }
}

export const solarIntensity = [takeEvery(FETCH_SOLAR_INTENSITY, fetchSolarIntensitySaga)];
